import React, { useRef, useState } from "react";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { ToggleButtonTwoOptions } from "../../../../../../../../react-core/Html/ToggleButtonTwoOptions";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { IJsonDate } from "../../../../../../../../Wrap/System/IJsonDate";
import { DrawdownPriceLockIcon } from "../../../../Common/SIPP/DrawdownDetails/Icon/DrawdownPriceLockIcon";
import { PoundLockIcon } from "../../../../../ToolsAndLiterature/Components/Icons/PoundLockIcon";
import { ProductOverviewChargeAction } from "../Action/ProductOverviewChargeAction";
import AriaTooltip from "../../../../../../../Shared/Tooltip/AriaTooltip";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { DrawdownPriceLockConfirmationMessage } from "../Constant/Content";

interface IDrawdownPriceLockProps {
    isAdmin: boolean;
    subAccountHierarchyId: string;
    lockApplied?: boolean;
    platformCharge?: string;
    chargeApplied?: number;
    appliedDate?: IJsonDate;
    onRefresh: () => void
}

export const DrawdownPriceLock = (props: IDrawdownPriceLockProps) => {
    const [lockApplied, setLockApplied] = useState<boolean>(props.lockApplied);
    const [showPriceLockConfirmLightbox, setShowPriceLockConfirmLightbox] = useState<boolean>(false);
    const wrapperRef = useRef(null);
    const renderPriceLockConfirmLightbox = () => {
        return (
            showPriceLockConfirmLightbox && (
                <Lightbox
                    show={showPriceLockConfirmLightbox}
                    title={"Drawdown Price Lock"}
                    contentAfterTitle={null}
                    onClose={() => {
                        setShowPriceLockConfirmLightbox(false);
                    }}
                    type={LightboxType.Modal}
                    cssWrapper="is-default-lightbox"
                >
                    <div>
                        <span style={{ float: "right" }}>
                            <PoundLockIcon />
                        </span>
                    </div>
                    <div className="mb-20">
                        Do you want to apply the Drawdown Price Lock?
                        <AriaTooltip cssWrapper="is-info-icon ml-5" showCloseButton={true}>
                            {
                                "The Drawdown Lock will be applied and will lock your client into the lowest possible platform charge."
                            }
                        </AriaTooltip>
                    </div>
                    <div>
                        {renderComfirmationMessage()}
                    </div>
                    <div className="row">
                        <div className="col-auto">
                            <button
                                className="btn secondary"
                                onClick={(val) => {
                                    wrapperRef.current.setValue(false);
                                    setShowPriceLockConfirmLightbox(false);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                        <div className="col-auto">
                            <button
                                className="btn primary"
                                onClick={(val) => {
                                    ProductOverviewChargeAction.updateDrawdownPriceLock(props.subAccountHierarchyId, true, () => {
                                        props.onRefresh();
                                        setLockApplied(true);
                                        setShowPriceLockConfirmLightbox(false);
                                    });
                                }}
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </Lightbox>
            )
        );
    };

    const renderComfirmationMessage = () => {
        return (
            (
                <div className="mb-20">
                    <p>{DrawdownPriceLockConfirmationMessage.paragraph1}</p>
                    <p>{DrawdownPriceLockConfirmationMessage.paragraph2}</p>
                    <span>{DrawdownPriceLockConfirmationMessage.paragraph3}</span>
                    <ul>
                        <li>{DrawdownPriceLockConfirmationMessage.list1}</li>
                        <li>{DrawdownPriceLockConfirmationMessage.list2}</li>
                        <li>{DrawdownPriceLockConfirmationMessage.list3}</li>
                        <li>{DrawdownPriceLockConfirmationMessage.list4}</li>
                        <li><strong>{DrawdownPriceLockConfirmationMessage.list5bold}</strong>{DrawdownPriceLockConfirmationMessage.list5}</li>
                    </ul>
                    <p>{DrawdownPriceLockConfirmationMessage.footer1}</p>
                    <p>{DrawdownPriceLockConfirmationMessage.footer2}</p>
                </div>
            ))
    }

    return (
        <div>
            {renderPriceLockConfirmLightbox()}
            <h2 className="h3 mb-5">Drawdown Price Lock</h2>
            <div className="panel-subtle">
                <div className="row mb-20">
                    <div className="col-6">
                        <div className="panel-total-income">
                            <div className="row">
                                <div className="col-auto">
                                    <DrawdownPriceLockIcon />
                                </div>
                                <div className="col-fluid">
                                    <h4 className="">Drawdown Price Lock</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <table className="table-subtle table-first-last-cell-padding-reset has-first-cell-highlighted mb-15 row-higher">
                            <tbody>
                                <tr>
                                    <th scope="row">Apply</th>
                                    <td>
                                        {lockApplied && !props.isAdmin && !checkPermission(UserClaim.AdviserPortalDrawdownPriceLockReadWrite) ? (
                                            <span>Yes</span>
                                        ) : (
                                            <ToggleButtonTwoOptions
                                                ref={wrapperRef}
                                                optionOne="No"
                                                optionTwo="Yes"
                                                value={lockApplied}
                                                onChange={(val) => {
                                                    if (val) {
                                                        setShowPriceLockConfirmLightbox(true);
                                                    } else {
                                                        ProductOverviewChargeAction.updateDrawdownPriceLock(props.subAccountHierarchyId, val, () => {
                                                            props.onRefresh();
                                                            setLockApplied(val);
                                                        });
                                                    }
                                                }}
                                            />
                                        )}
                                    </td>
                                </tr>
                                {lockApplied && (
                                    <>
                                        <tr>
                                            <th scope="row">Applied</th>
                                            <td>
                                                {props.appliedDate != undefined
                                                    ? JsonDateParser.getFormatDate(props.appliedDate, "dd/MM/yyyy")
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Charge applied</th>
                                            <td className="cell-right">{props.chargeApplied == undefined || props.chargeApplied == 0 ? "N/A" : `${props.chargeApplied.toFixed(2)}%`}</td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-auto">
                        Drawdown price lock applied date
                    </div>
                    <div className="col-fluid">
                        {props.appliedDate != undefined && props.lockApplied
                            ? JsonDateParser.getFormatDateString(
                                JsonDateParser.toDate(props.appliedDate),
                                "dd MM yyyy",
                                true,
                                true
                            )
                            : "N/A"}
                    </div>
                </div>
            </div>
        </div>
    );
};
